// This program is the real Navbar Component where the screen size is checked and toggled between Mobilemenu and Megamenu. Also the Book Appointment Button and Call Phone Button are added
"use client";

import Image from "next/image";
import Link from "next/link";
import React, { useState, useEffect } from "react";

import BookAppointmentButton from "@/components/utilities/BookAppointmentButton";
import CallPhone from "@/components/utilities/CallPhone";

import Megamenu from "./Megamenu";
import MobileMenu from "./Mobilemenu";
import ThemeSwitcher from "./ThemeSwitcher";
import logo from "../../../public/images/logo/trichos-white-tri.svg";

const Navbar = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    // Function to update screen size state
    const updateScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 768); // Define large screen as >= 768px
    };

    updateScreenSize(); // Check screen size on mount
    window.addEventListener("resize", updateScreenSize); // Add resize listener

    return () => window.removeEventListener("resize", updateScreenSize); // Cleanup on unmount
  }, []);

  return (
    <nav className="flex-between sticky top-0 z-50 w-full  gap-5 bg-violet-950 px-6 py-2 text-white shadow-none dark:shadow-none">
      <Link href="/" className="flex flex-col">
        <div className="flex items-center gap-1">
          <Image src={logo} width={23} height={23} alt="Logo" />
          <p className="h2-bold text-white dark:text-light-900 ">TRICHOS</p>
        </div>
        <div className="text-xs">Best Hair Transplant Center in India</div>
      </Link>

      <div className="flex-between gap-5">
        {/* <ThemeSwitcher /> */}
        {/* Conditional rendering based on screen size */}
        <div className="flex-between gap-5">
          {/* Adjust the order dynamically based on screen size */}
          {isLargeScreen ? (
            <>
              <Megamenu />
              <Link href="/appointment">
                <BookAppointmentButton
                  name="Book Appointment"
                  bgColor="bg-white"
                  textColor="text-black"
                  showIcon={false}
                  hoverColor="hover:bg-blue-800"
                  paddingx="px-1"
                  paddingy="py-1"
                />
              </Link>
            </>
          ) : (
            <>
              <Link href="/appointment">
                <BookAppointmentButton
                  name="Book"
                  bgColor="bg-white"
                  textColor="text-black"
                  showIcon={false}
                  hoverColor="hover:bg-blue-800"
                  paddingx="px-0"
                  paddingy="py-0"
                />
              </Link>
              <CallPhone />
              <MobileMenu />
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
